module.exports = __webpack_public_path__ + "img/dp-lc-bg.6e83ac4c.png";